import {
  Serializer,
  Question,
} from 'survey-core';
import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from 'survey-react-ui';
import React from 'react';

interface RegisterCustomQuestionProps<TComponentProps = any> {
  component: React.ComponentType<TComponentProps>;
  getProps?: () => TComponentProps;
  questionType: string;
}
export const registerCustomReactQuestion = <
  TComponentProps = any,
>({
    component,
    getProps,
    questionType,
  }: RegisterCustomQuestionProps<TComponentProps>) => {
  class CustomQuestionModel extends Question {
    getType (): string {
      return questionType;
    }
  }

  class CustomQuestion extends SurveyQuestionElementBase {
    renderElement () {
      const props = getProps?.();
      return (
        // React.createElement has strict overloads It expects either: A 'FunctionComponent<{}>' OR 'ComponentClass<{}, any>',
        // this is a limitation in how TypeScript handles generic inference inside React's factory typing.
        // Even though you cast to ComponentType<any> at the point of rendering, using generics up to that point still gives
        // Type-safe component input, Type-safe getProps(), prop mapping logic remains type-checked
        React.createElement(component as React.ComponentType<any>, props)
      );
    }
  }

  Serializer.addClass(
    questionType,
    [ { name: questionType } ],
    () => new CustomQuestionModel(''),
    'question',
  );

  ReactQuestionFactory.Instance.registerQuestion(
    questionType,
    (props: any) => {
      return React.createElement(CustomQuestion, props);
    },
  );
};
